import React from "react";
import SupplierHome from "../../components/MainPage/SupplierHomePage/Home";

const SupplierHomePage = () => {
	return (
		<>
			<SupplierHome />
		</>
	);
};

export default SupplierHomePage;
